var isValidPlaceholderData = function isValidPlaceholderData(placeholderData) {
  return (placeholderData === null || placeholderData === void 0 ? void 0 : placeholderData.data) && 'url' in placeholderData.data && 'name' in placeholderData.data;
};
export var extractPlaceHolderCardState = function extractPlaceHolderCardState(placeholderData) {
  return isValidPlaceholderData(placeholderData) ? {
    status: 'resolved',
    metadataStatus: undefined,
    details: placeholderData
  } : undefined;
};